import { readMoreToken } from './config'

type ParsePostContentArgs = {
    content: string | null
    removeCut: boolean
}

type ParsePostContentResult = {
    hasCut: boolean
    content: string
}

export function parseContent({ content, removeCut }: ParsePostContentArgs): ParsePostContentResult {
    if (!content) {
        return { hasCut: false, content: '' }
    }

    const parts = content.split(readMoreToken)

    if (parts.length === 1) {
        return { hasCut: false, content }
    }

    if (removeCut) {
        return { hasCut: false, content: content.replace(readMoreToken, '') }
    }

    return { hasCut: true, content: parts[0]! }
}

export function splitContent(content: string): string[] {
    return content.split(readMoreToken)
}

export function joinContent(parts: string[]): string {
    return parts.join(readMoreToken)
}
